import {Injectable} from '@angular/core';
import {
  AsmExpireModalStatic,
  CancelOrderModalStatic, CancelSubscriptionModalStatic,
  ConfirmModalStatic,
  CpConfigWarningModalStatic,
  NipErrorModalStatic
} from '../modals/staticModalsData';
import {CommonModalStaticEnum} from '../modals/all-modals-config';
import {CommonModalService} from './common-modal.service';
import {ProductViewModel} from '../../model/view/ProductViewModel';

@Injectable({
  providedIn: 'root'
})
export class StaticModalsService {
  constructor(
    private commonModalService: CommonModalService
  ) {

  }

  public show(
    _staticModalName: CommonModalStaticEnum,
    _data: any // type any because data comes different from outside
  ): void {
      this.commonModalService.setData(StaticModalsService.toModalData(_staticModalName, _data));
  }

  private static toModalData(
    _staticModalName: String,
    _data: any
  ): any {
    switch (_staticModalName) {
      case CommonModalStaticEnum.COMPLETE_PAIR_CONFIGURATOR_WARNING:
        return new CpConfigWarningModalStatic(_data);
      case CommonModalStaticEnum.CANCEL_ORDER_CONFIRMATION:
        return new CancelOrderModalStatic(_data);
      case CommonModalStaticEnum.CANCEL_SUBSCRIPTION_CONFIRMATION:
        return new CancelSubscriptionModalStatic(_data);
      case CommonModalStaticEnum.NIP_ERROR:
        return new NipErrorModalStatic(_data);
      case CommonModalStaticEnum.ASM_TIMEOUT:
        return new AsmExpireModalStatic(_data);
      case CommonModalStaticEnum.CONFIRM_POPUP:
        return new ConfirmModalStatic(_data)
    }
  }

}


